// extracted by mini-css-extract-plugin
export default {"root":"_9-GdYJgz"};